import { Country } from 'react-phone-number-input'

const LanguageToCountryCode: Record<string, Country> = {
  en: 'US',
  'en-SA': 'SA',
  'ar-SA': 'SA',
  'en-US': 'US',
  fr: 'FR',
  iv: 'FR',
  ar: 'AE',
  es: 'ES',
  it: 'IT',
  pt: 'PT',
}

export function getCountryCode(language: string): Country {
  return LanguageToCountryCode[language] || 'FR'
}
